// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.you-won-wrapper {
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
  max-height: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
}
.you-won-wrapper .nkl-modal-wrap {
  display: table-cell;
}
.game-loader-overlay.nkl-modal {
  top: 0;
  margin-top: 0;
}
.nkl-modal {
  padding-bottom: 0;
}
.you-won-dialog {
  font-family: 'FiraGO', Arial, Helvetica, sans-serif;
  color: #292929;
  background: #ffffff;
  position: relative;
  max-height: 100%;
  border-radius: 10px;
}
.you-won-dialog .content-container {
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
}
.you-won-dialog .content-block {
  width: 100%;
  text-align: center;
}
.you-won-dialog .nkl-modal-content {
  border-radius: 20px;
  box-shadow: none;
}
.you-won-dialog .nkl-modal-body {
  width: 100%;
  margin: 0;
}
.you-won-dialog .nkl-modal-header {
  box-shadow: none;
  background: #ffffff;
  min-height: 70px;
  font-weight: bold;
}
.you-won-dialog .nkl-modal-title {
  font-weight: 700;
  text-align: center;
}
.you-won-dialog .nkl-modal-footer {
  display: block;
  text-align: center;
}
.you-won-dialog .center {
  text-align: center;
}
.you-won-dialog .text-award {
  font-size: 57px;
  line-height: 57px;
  font-weight: 700;
  text-align: center;
}
.you-won-dialog .text-award-label {
  font-size: 20px;
  line-height: 20px;
  font-weight: 700;
  text-align: center;
  margin-top: -5px;
}
.you-won-dialog .text-header {
  font-size: 48px;
  line-height: 48px;
  font-weight: 700;
}
.you-won-dialog .text-body {
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
}
.you-won-dialog .award-rings-svg {
  position: relative;
  height: 100%;
  display: block;
  margin: 0 auto;
}
.you-won-dialog .award-display {
  position: relative;
  width: 200px;
  height: 200px;
  display: inline-block;
  background-size: cover;
}
.you-won-dialog .award-display__graphic-container {
  position: absolute;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
.you-won-dialog .award-display__text-container {
  position: absolute;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.you-won-dialog .footer {
  margin: 30px 10px 10px 10px;
  flex: 0 0 auto;
}
.you-won-dialog .footer-action-group {
  display: block;
  text-align: center;
  justify-content: flex-end;
}
.you-won-dialog {
  width: 400px !important;
}
.you-won-dialog .content-container {
  flex-direction: column;
}
#particle-0,
#particle-5,
#particle-6,
#particle-18,
#particle-30 {
  visibility: visible;
}
@media (orientation: landscape) and (max-height: 499px) {
  .you-won-dialog {
    width: 500px !important;
  }
  .you-won-dialog .content-container {
    flex-direction: row;
  }
  #particle-0,
  #particle-5,
  #particle-6,
  #particle-18,
  #particle-30 {
    visibility: hidden;
  }
}
.game-modal-wrap {
  width: 100%;
}
.particle-container {
  width: 100%;
  height: 100%;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  justify-content: center;
  display: flex;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}
@font-face {
  font-family: "FiraGO";
  font-weight: 100 500;
  src: url("https://paper.biw.cloud/fonts/FiraGO/FiraGO-Book.woff") format("woff"), url("https://paper.biw.cloud/fonts/FiraGO/FiraGO-Book.woff2") format("woff2"), url("https://paper.biw.cloud/fonts/FiraGO/FiraGO-Book.eot") format("eot"), url("https://paper.biw.cloud/fonts/FiraGO/FiraGO-Book.otf") format("otf");
}
@font-face {
  font-family: "FiraGO";
  font-weight: 600 900;
  src: url("https://paper.biw.cloud/fonts/FiraGO/FiraGO-Bold.woff") format("woff"), url("https://paper.biw.cloud/fonts/FiraGO/FiraGO-Bold.woff2") format("woff2"), url("https://paper.biw.cloud/fonts/FiraGO/FiraGO-Bold.eot") format("eot"), url("https://paper.biw.cloud/fonts/FiraGO/FiraGO-Bold.otf") format("otf");
}
.game-loader-overflow {
  overflow: hidden;
}
.game-loader-overlay {
  min-width: 100vw;
  min-height: 100vh;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
}
.game-loader-overlay-wrap.nkl-modal-wrap {
  z-index: 1500;
  overflow: hidden;
}
.game-loader-overlay-enter,
.game-loader-overlay-appear {
  transform: scale(0.4);
  opacity: 0;
}
.game-loader-overlay-appear-active,
.game-loader-overlay-enter-active {
  transform: scale(1);
  opacity: 1;
  transition: 200ms;
  transition-timing-function: ease-in-out;
}
.game-loader {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #0b0b0b;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.game-loader .nkl-modal {
  max-width: calc(100% - (2 * 20px));
  padding-bottom: 0;
}
.game-loader .nkl-modal-mask {
  height: 100%;
}
.game-loader .game-frame {
  width: 0;
  height: 0;
  min-width: 100%;
  min-height: 100%;
  display: none;
}
.game-loader .game-frame.is-loaded {
  display: block;
}
.game-loader .game-container {
  background-color: #0b0b0b;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  position: relative;
}
.game-loader .game-container__frame {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: opacity 300ms;
}
.game-loader .game-container__frame iframe {
  border: none;
}
.game-loader.loaded .game-container__frame {
  opacity: 1;
}
.game-loader .loading-spinner {
  position: relative;
  width: 80%;
}
.game-loader .game-navbar {
  flex-basis: auto;
  flex-grow: 0;
  flex-shrink: 0;
  justify-content: flex-end;
  z-index: 1010;
}
.game-loader .game-navbar .nkl-menu-item {
  vertical-align: middle;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./node_modules/.pnpm/@nackle+game-loader-component-v2@1.1.51_@babel+plugin-syntax-flow@7.26.0_@babel+core@7.26.9___xwaytvp6ew64gumw4spnkr7vei/node_modules/@nackle/game-loader-component-v2/static/loader.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,MAAM;EACN,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mDAAmD;EACnD,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;;;;;EAKE,mBAAmB;AACrB;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;EACA;;;;;IAKE,kBAAkB;EACpB;AACF;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,qTAAqT;AACvT;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,qTAAqT;AACvT;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;;EAEE,qBAAqB;EACrB,UAAU;AACZ;AACA;;EAEE,mBAAmB;EACnB,UAAU;EACV,iBAAiB;EACjB,uCAAuC;AACzC;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,YAAY;AACd","sourcesContent":[".you-won-wrapper {\n  position: absolute;\n  z-index: 0;\n  width: 100%;\n  height: 100%;\n  max-height: 100%;\n  overflow-y: hidden;\n  overflow-x: hidden;\n}\n.you-won-wrapper .nkl-modal-wrap {\n  display: table-cell;\n}\n.game-loader-overlay.nkl-modal {\n  top: 0;\n  margin-top: 0;\n}\n.nkl-modal {\n  padding-bottom: 0;\n}\n.you-won-dialog {\n  font-family: 'FiraGO', Arial, Helvetica, sans-serif;\n  color: #292929;\n  background: #ffffff;\n  position: relative;\n  max-height: 100%;\n  border-radius: 10px;\n}\n.you-won-dialog .content-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n}\n.you-won-dialog .content-block {\n  width: 100%;\n  text-align: center;\n}\n.you-won-dialog .nkl-modal-content {\n  border-radius: 20px;\n  box-shadow: none;\n}\n.you-won-dialog .nkl-modal-body {\n  width: 100%;\n  margin: 0;\n}\n.you-won-dialog .nkl-modal-header {\n  box-shadow: none;\n  background: #ffffff;\n  min-height: 70px;\n  font-weight: bold;\n}\n.you-won-dialog .nkl-modal-title {\n  font-weight: 700;\n  text-align: center;\n}\n.you-won-dialog .nkl-modal-footer {\n  display: block;\n  text-align: center;\n}\n.you-won-dialog .center {\n  text-align: center;\n}\n.you-won-dialog .text-award {\n  font-size: 57px;\n  line-height: 57px;\n  font-weight: 700;\n  text-align: center;\n}\n.you-won-dialog .text-award-label {\n  font-size: 20px;\n  line-height: 20px;\n  font-weight: 700;\n  text-align: center;\n  margin-top: -5px;\n}\n.you-won-dialog .text-header {\n  font-size: 48px;\n  line-height: 48px;\n  font-weight: 700;\n}\n.you-won-dialog .text-body {\n  font-size: 16px;\n  line-height: 16px;\n  font-weight: 700;\n}\n.you-won-dialog .award-rings-svg {\n  position: relative;\n  height: 100%;\n  display: block;\n  margin: 0 auto;\n}\n.you-won-dialog .award-display {\n  position: relative;\n  width: 200px;\n  height: 200px;\n  display: inline-block;\n  background-size: cover;\n}\n.you-won-dialog .award-display__graphic-container {\n  position: absolute;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n.you-won-dialog .award-display__text-container {\n  position: absolute;\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n.you-won-dialog .footer {\n  margin: 30px 10px 10px 10px;\n  flex: 0 0 auto;\n}\n.you-won-dialog .footer-action-group {\n  display: block;\n  text-align: center;\n  justify-content: flex-end;\n}\n.you-won-dialog {\n  width: 400px !important;\n}\n.you-won-dialog .content-container {\n  flex-direction: column;\n}\n#particle-0,\n#particle-5,\n#particle-6,\n#particle-18,\n#particle-30 {\n  visibility: visible;\n}\n@media (orientation: landscape) and (max-height: 499px) {\n  .you-won-dialog {\n    width: 500px !important;\n  }\n  .you-won-dialog .content-container {\n    flex-direction: row;\n  }\n  #particle-0,\n  #particle-5,\n  #particle-6,\n  #particle-18,\n  #particle-30 {\n    visibility: hidden;\n  }\n}\n.game-modal-wrap {\n  width: 100%;\n}\n.particle-container {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  margin-left: auto;\n  margin-right: auto;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n}\n@font-face {\n  font-family: \"FiraGO\";\n  font-weight: 100 500;\n  src: url(\"https://paper.biw.cloud/fonts/FiraGO/FiraGO-Book.woff\") format(\"woff\"), url(\"https://paper.biw.cloud/fonts/FiraGO/FiraGO-Book.woff2\") format(\"woff2\"), url(\"https://paper.biw.cloud/fonts/FiraGO/FiraGO-Book.eot\") format(\"eot\"), url(\"https://paper.biw.cloud/fonts/FiraGO/FiraGO-Book.otf\") format(\"otf\");\n}\n@font-face {\n  font-family: \"FiraGO\";\n  font-weight: 600 900;\n  src: url(\"https://paper.biw.cloud/fonts/FiraGO/FiraGO-Bold.woff\") format(\"woff\"), url(\"https://paper.biw.cloud/fonts/FiraGO/FiraGO-Bold.woff2\") format(\"woff2\"), url(\"https://paper.biw.cloud/fonts/FiraGO/FiraGO-Bold.eot\") format(\"eot\"), url(\"https://paper.biw.cloud/fonts/FiraGO/FiraGO-Bold.otf\") format(\"otf\");\n}\n.game-loader-overflow {\n  overflow: hidden;\n}\n.game-loader-overlay {\n  min-width: 100vw;\n  min-height: 100vh;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n}\n.game-loader-overlay-wrap.nkl-modal-wrap {\n  z-index: 1500;\n  overflow: hidden;\n}\n.game-loader-overlay-enter,\n.game-loader-overlay-appear {\n  transform: scale(0.4);\n  opacity: 0;\n}\n.game-loader-overlay-appear-active,\n.game-loader-overlay-enter-active {\n  transform: scale(1);\n  opacity: 1;\n  transition: 200ms;\n  transition-timing-function: ease-in-out;\n}\n.game-loader {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #0b0b0b;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n.game-loader .nkl-modal {\n  max-width: calc(100% - (2 * 20px));\n  padding-bottom: 0;\n}\n.game-loader .nkl-modal-mask {\n  height: 100%;\n}\n.game-loader .game-frame {\n  width: 0;\n  height: 0;\n  min-width: 100%;\n  min-height: 100%;\n  display: none;\n}\n.game-loader .game-frame.is-loaded {\n  display: block;\n}\n.game-loader .game-container {\n  background-color: #0b0b0b;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-basis: 0;\n  flex-grow: 1;\n  flex-shrink: 1;\n  position: relative;\n}\n.game-loader .game-container__frame {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  opacity: 0;\n  transition: opacity 300ms;\n}\n.game-loader .game-container__frame iframe {\n  border: none;\n}\n.game-loader.loaded .game-container__frame {\n  opacity: 1;\n}\n.game-loader .loading-spinner {\n  position: relative;\n  width: 80%;\n}\n.game-loader .game-navbar {\n  flex-basis: auto;\n  flex-grow: 0;\n  flex-shrink: 0;\n  justify-content: flex-end;\n  z-index: 1010;\n}\n.game-loader .game-navbar .nkl-menu-item {\n  vertical-align: middle;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
